import { PRICE_RANGE } from "../../constants";

const selects = [
  {
    name: "filter.title.type",
    key: "type",
    options: [],
    model: null,
    type: "single",
    translate: true
  },
  {
    name: "filter.title.color",
    key: "color",
    options: [],
    model: null,
    type: "single",
    translate: false
  },
  {
    name: "filter.title.size",
    key: "sizes",
    options: [],
    model: null,
    type: "single",
    translate: false
  },
  {
    name: "filter.title.brand",
    key: "brand",
    options: [],
    model: [],
    type: "multiple",
    translate: false
  },
  {
    name: "filter.title.store",
    key: "store",
    options: [],
    model: [],
    type: "multiple",
    translate: true
  },
  {
    name: "filter.title.price_range",
    key: "priceRange",
    options: null,
    model: PRICE_RANGE,
    type: "range",
    translate: false
  }
];

const state = {
  selects: selects,

  fields: {
    searchString: null,
    sex: null,
    category: null,
    store: null,
    sustainable: null,
    onSale: null
  }
};

const getters = {
  getSelects: state => state.selects.filter(select => select.key !== "type"),

  getSelectsWithTypeSelect: state => state.selects,

  getSearchString: state => state.fields.searchString,

  getSex: state => state.fields.sex,

  getCategory: state => state.fields.category,

  getStore: state => state.fields.store,

  getSustainable: state => state.fields.sustainable,

  onSale: state => state.fields.onSale,

  getType: state => state.selects.find(filter => filter.key === "type").model,

  isAFilterApplied: state =>
    Object.values(state.fields).some(field => field) ||
    state.selects.some(select => select.model),

  isANonNavFilterApplied: state =>
    Object.keys(state.fields).some(key => {
      return key !== "category" && key !== "sex" && state.fields[key];
    }) ||
    state.selects.some(select => {
      return (
        (!Array.isArray(select.model) && select.model !== null) ||
        (Array.isArray(select.model) &&
          select.model.length > 0 &&
          select.key !== "priceRange")
      );
    })
};

const actions = {};

const mutations = {
  setFilters(state, payload) {
    state.selects = payload;
  },
  resetSelections(state) {
    state.selects.map(filter => {
      if (/color|type|sizes/.test(filter.key)) {
        filter.model = null;
      } else if (/brand|store/.test(filter.key)) {
        filter.model = [];
      } else {
        filter.model = PRICE_RANGE;
      }
    });
  },
  resetCommons(state) {
    state.selects.map(filter => {
      if (/color|type|sizes/.test(filter.key)) {
        filter.model = null;
      } else if (/brand|store/.test(filter.key)) {
        filter.model = [];
      } else {
        filter.model = PRICE_RANGE;
      }
    });
    state.fields.searchString = null;
    state.fields.sustainable = null;
    state.fields.onSale = null;
  },
  reset(state) {
    state.selects.map(filter => {
      if (/color|type|sizes/.test(filter.key)) {
        filter.model = null;
      } else if (/brand|store/.test(filter.key)) {
        filter.model = [];
      } else {
        filter.model = PRICE_RANGE;
      }
    });
    state.fields.searchString = null;
    state.fields.sex = null;
    state.fields.category = null;

    state.fields.sustainable = null;
    state.fields.onSale = null;
  },
  setOneSelect(state, payload) {
    let index = state.selects.findIndex(filter => filter.key === payload.key);
    if (index !== -1) {
      state.selects[index] = payload;
    }
  },
  setOneSelectValue(state, payload) {
    let index = state.selects.findIndex(filter => filter.key === payload.key);
    if (index !== -1) {
      state.selects[index].model = payload.value;
    }
  },
  addSelectOptions(state, payload) {
    const index = state.selects.findIndex(filter => filter.key === payload.key);
    if (index !== -1) {
      state.selects[index].options = payload.options;
    }
  },
  setFieldByKeyValue(state, payload) {
    const { key, value } = payload;
    if (/color|type|sizes|brand|store/.test(key)) {
      let index = state.selects.findIndex(filter => filter.key === key);
      if (index !== -1) {
        state.selects[index].model = value;
      }
    } else {
      state.fields[key] = value;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
